export default "__VITE_ASSET__DYw6Lr4r__"